<template>
  <v-app>
    <v-dialog v-model="dialog" max-width="600" persistent>
      <v-card>
        <v-card-title>
          Add New Quiz
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                  label="Quiz Title"
                  v-model="quiz.title"
                  outlined
                  dense
              >
              </v-text-field>
              <span class="text-danger" v-if="$v.quiz.title.$error">Title is required</span>
            </v-col>
            <!--            <pre>{{assignedTeacherCourseList}}</pre>-->

            <!--                        <v-col cols="6">-->
            <!--                            <v-select-->
            <!--                                    label="Academic Year"-->
            <!--                                    v-model="quiz.academic_year_id"-->
            <!--                                    :items="academic_years"-->
            <!--                                    item-text="title"-->
            <!--                                    item-value="id"-->
            <!--                                    outlined-->
            <!--                                    dense-->
            <!--                            >-->
            <!--                            </v-select>-->
            <!--                        </v-col>-->
            <v-col cols="6">
              <v-select
                  label="Course"
                  v-model="quiz.course_id"
                  :items="teacher_course_list"
                  item-text="title"
                  item-value="id"
                  outlined
                  dense
              >
              </v-select>
              <span class="text-danger" v-if="$v.quiz.course_id.$error">Course is required</span>
            </v-col>
            <!--                        <v-col cols="6">-->
            <!--                            <v-select-->
            <!--                                    label="Courses"-->
            <!--                                    v-model="quiz.course_id"-->
            <!--                                    :items="courses"-->
            <!--                                    item-text="title"-->
            <!--                                    item-value="id"-->
            <!--                                    outlined-->
            <!--                                    dense-->
            <!--                            >-->
            <!--                            </v-select>-->
            <!--                        </v-col>-->
            <v-col cols="6">
              <v-select
                  label="Type"
                  v-model="quiz.type"
                  :items="types"
                  item-text="title"
                  item-value="value"
                  outlined
                  dense
              >
              </v-select>
            </v-col>
            <v-col cols="12">
              <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="quiz.schedule_at"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="quiz.schedule_at"
                      label="Scheduled At"
                      append-icon="mdi-calendar"
                      readonly
                      outlined
                      dense
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="quiz.schedule_at"
                    no-title
                    scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                      text
                      color="primary"
                      @click="menu = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                      text
                      color="primary"
                      @click="$refs.menu.save(quiz.schedule_at)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
                <span class="text-danger" v-if="$v.quiz.schedule_at.$error">Schedule at required</span>
              </v-menu>
            </v-col>
            <v-col cols="12" class="text-right pull-right float-right">
              <v-btn class="btn btn-standard" depressed @click="cancelQuizDialog">
                Cancel
              </v-btn>
              <v-btn class="btn btn-primary text-white ml-3" :loading="isBusy" @click="createOrUpdate"
                     depressed>
                Save
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import {QuizMixin} from "@/mixins/QuizMixin";
import {required} from "vuelidate/lib/validators";
import AcademicClassTeacherService
  from "@/core/services/academic-class/class-teacher/AcademicClassTeacherService";
const academicClassTeacherService = new AcademicClassTeacherService();

export default {
  name: "AddQuiz",
  props: ['dialog'],
  mixins: [QuizMixin],
  validations: {
    quiz: {
      title: {required},
      course_id: {required},
      schedule_at: {required},
    }
  }, data() {
    return {
      isBusy: false,
      menu: false,
      teacher_course_list: [],
    }
  }, mounted() {
    this.getAssignedTeacherCoursesList()
  },
  methods: {
    createOrUpdate() {

      this.$v.quiz.$touch();
      if (this.$v.quiz.$error) {
        setTimeout(() => {
          this.$v.quiz.$reset();
        }, 3000);
      } else {
        let fd = this.quiz;
        if (this.edit) {
          this.__updateQuiz(fd);
        } else {
          this.__createQuiz(fd);
        }
      }
    },
    cancelQuizDialog() {
      this.$emit('close-dialog')
    },
    getAssignedTeacherCoursesList() {
      academicClassTeacherService.getCourseByTeacherId(this.currentUser.id).then(response => {
        this.teacher_course_list = response.data.courses;
      }).catch((err) => {
        // console.log(err)
      }).finally(() => {
      });
    },
  }
}
</script>

<style scoped>

</style>